<template>
  <div>
    <page-title title="作品状态">
      <div style="display: flex; justify-content: space-between">
        <div class="title-status">
          <p>{{ getStatusCode(reviewForm.status) }}</p>
          <div class="audit" v-if="reviewForm.opinion">
            审核意见：{{ reviewForm.opinion }}
          </div>
        </div>
        <el-button
          style="height: 34px"
          size="small"
          type="primary"
          @click="goback"
          >返回</el-button
        >
      </div>
    </page-title>
    <div class="work-review-container">
      <div class="left-section">
        <el-form
          :disabled="true"
          :model="uploadForm"
          :rules="rules"
          label-width="130px"
          size="small"
        >
          <el-form-item label="上传作品类型：" prop="type">
            <el-select v-model="uploadForm.type">
              <el-option label="图片" value="1"></el-option>
              <el-option label="音频" value="2"></el-option>
              <el-option label="视频" value="3"></el-option>
              <!-- 可根据实际情况添加更多选项 -->
            </el-select>
          </el-form-item>
          <el-form-item
            label="证明文件："
            prop="type"
            v-if="uploadForm.simCetiUrl"
          >
            <div v-for="(item, index) in uploadForm.simCetiUrl?.split(',')">
              <el-link
                :key="index"
                :href="item"
                target="_blank"
                type="primary"
                :underline="false"
                >{{ uploadForm.simCetiUrlName?.split(",")[index] }}</el-link
              >
            </div>
          </el-form-item>
          <!-- <el-form-item label="请提交证明：" prop="project">
                        {{ uploadForm.project || '证明文件.docx' }}
                    </el-form-item> -->
          <!-- <div class="title-status" style="margin-bottom: 16px;">共1张(12.27MB)</div> -->
          <template v-if="uploadForm.type != 2">
            <imgOrVideoDetail
              :worksSize="uploadForm.size"
              :resourceType="uploadForm.type"
              :resourceUrl="uploadForm.file"
            ></imgOrVideoDetail>
            <Similar></Similar>
          </template>
          <audioDetail
            :fileName="uploadForm.fileName"
            :duration="uploadForm.duration"
            :resourceUrl="uploadForm.file"
            :worksSize="uploadForm.size"
            v-else
          ></audioDetail>

          <div v-if="uploadForm.simCetiUrl">
            <Similar :similarList="similarList" />
          </div>
        </el-form>
      </div>
      <div class="right-section">
        <el-form
          :disabled="true"
          :model="reviewForm"
          :rules="rules"
          ref="reviewForm"
          label-width="130px"
          size="small"
        >
          <el-form-item label="作品是否登记：" prop="isRegistered">
            <el-radio-group v-model="reviewForm.isRegistered">
              <el-radio label="1">已登记</el-radio>
              <el-radio label="0">未登记</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="reviewForm.isRegistered == 1"
            label="作品登记号："
            prop="registrationNumber"
          >
            <el-input
              v-model="reviewForm.registrationNumber"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="reviewForm.isRegistered == 1"
            label="登记证书："
            prop="certificateFile"
          >
            <!-- <el-input
              v-model="reviewForm.certificateFile"
              placeholder="证明文件.docx"
            ></el-input> -->
            <el-link
              :href="reviewForm.certificateFile"
              :underline="false"
              target="_blank"
              >{{ reviewForm.certificateFile }}</el-link
            >
          </el-form-item>
          <el-form-item label="标题：" prop="title">
            <el-input
              v-model="reviewForm.title"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="核心关键词：" prop="keywords">
            <el-input
              maxlength="20"
              show-word-limit
              type="textarea"
              v-model="reviewForm.keywords"
              placeholder="0/20关键词"
            ></el-input>
            <!-- <div class="keyword-tips">多个关键词请用，分隔</div> -->
            <div class="recommended-keywords">
              推荐关键词
              <span
                v-for="(keyword, index) in recommendedKeywords"
                :key="index"
              >
                {{ keyword }}
              </span>
            </div>
          </el-form-item>
          <el-form-item label="分类：" prop="category">
            <el-select v-model="reviewForm.category" style="width: 100%">
              <el-option
                v-for="item in categorizeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创作完成日期：" prop="creationDate">
            <el-date-picker
              v-model="reviewForm.creationDate"
              style="width: 100%"
              type="date"
              placeholder="请选择"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="创作完成地点：" prop="creationPlace">
            <el-input
              v-model="reviewForm.creationPlace"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="肖像权：" prop="portraitRight">
            <el-radio-group v-model="reviewForm.portraitRight">
              <el-radio label="1">有授权</el-radio>
              <el-radio label="2">无授权</el-radio>
              <el-radio label="3">不涉及授权</el-radio>
            </el-radio-group>
            <div class="title-status">作品中疑似设计肖像权的任务识别</div>
          </el-form-item>
          <div class="automatic">
            <div class="automatic-tit">以下内容无需编辑，由系统自动录入：</div>
            <div class="automatic-count">
              <div>创作性质：原创</div>
              <div>权利范围：全部权利</div>
              <div>著作权人：企业/个人认证名称</div>
            </div>
          </div>
        </el-form>
        <el-form
          :disabled="isDisable"
          :model="reviewForm"
          ref="form"
          label-width="130px"
          size="small"
        >
          <el-form-item label="审核意见">
            <el-input
              type="textarea"
              v-model="reviewForm.opinion"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="!isDisable">
            <el-button @click="rejectReview">审核拒绝</el-button>
            <el-button type="primary" @click="approveReview"
              >审核通过</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-dialog
      title="审核拒绝"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
    >
      <el-form
        :model="dialogForm"
        ref="refuseForm"
        :rules="refuseRules"
        label-width="80px"
      >
        <el-form-item label="拒绝原因" prop="reason">
          <el-input
            maxlength="200"
            show-word-limit
            v-model="dialogForm.reason"
            type="textarea"
            :rows="3"
            placeholder="请输入拒绝原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmRefuse('refuseForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import imgOrVideoDetail from "./imgOrVideoDetail.vue";
import audioDetail from "./audioDetail.vue";
import Similar from "./similar.vue";
import {
  prodDetail,
  getCategorize,
  getPicture,
  updateStatus,
} from "@/api/works";
export default {
  name: "detailsView",
  components: {
    PageTitle,
    CusPagination,
    imgOrVideoDetail,
    audioDetail,
    Similar,
  },
  created() {
    this.getCategorizeFn();
    this.getPictureFn();
    this.getDetail();
  },
  data() {
    return {
      dialogVisible: false,
      dialogForm: {
        reason: "",
      },
      uploadForm: {
        type: "1",
        certificate: "",
        file: "",
        size: "",
        duration: "",
        workSize: "",
        fileName: "",
        simCetiUrl: "",
        simCetiUrlName: "",
        simImage: "",
        simResource: "",
      },
      reviewForm: {
        isRegistered: "1",
        registrationNumber: "",
        certificateFile: "",
        title: "",
        keywords: "",
        category: "",
        creationDate: "",
        creationPlace: "",
        portraitRight: "",
        nature: "创作性质: 原创",
        scope: "权利范围: 全部权利",
        author: "著作权人: 企业/个人认证名称",
        opinion: "",
        status: "",
      },
      rules: {
        type: [
          { required: true, message: "请选择上传作品类型", trigger: "change" },
        ],
        project: [
          { required: true, message: "请上传证明文件", trigger: "blur" },
        ],
        isRegistered: [
          { required: true, message: "请选择作品是否登记", trigger: "change" },
        ],
        registrationNumber: [
          { required: true, message: "请输入作品登记号", trigger: "blur" },
        ],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        keywords: [
          {
            required: true,
            max: 20,
            message: "关键词不能超过20个字符",
            trigger: "blur",
          },
        ],
        category: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
        creationDate: [
          { required: true, message: "请选择创作完成日期", trigger: "change" },
        ],
        creationPlace: [
          { required: true, message: "请输入创作完成地点", trigger: "blur" },
        ],
        portraitRight: [
          { required: true, message: "请选择肖像权情况", trigger: "change" },
        ],
      },
      refuseRules: {
        reason: [
          { required: true, message: "请输入拒绝原因", trigger: "submit" },
        ],
      },
      recommendedKeywords: [],
      categorizeList: [],
    };
  },
  computed: {
    isDisable() {
      return this.$route.params.type == "1";
    },
    currentId() {
      return this.$route.params.id;
    },
    similarList() {
      const list = {
        similarImage: [],
        similarResource: [],
      };
      if (this.uploadForm.simCetiUrl) {
        list.similarImage = this.uploadForm.simImage
          ? JSON.parse(this.uploadForm.simImage)
          : [];
        list.similarResource = this.uploadForm.simResource
          ? JSON.parse(this.uploadForm.simResource)
          : [];
      }
      return list;
    },
  },
  methods: {
    getDetail() {
      this.$ajax.get(prodDetail(this.currentId)).then((res) => {
        if (res.data.code == 200) {
          const data = res.data.data;
          // 使用对象解构和属性重命名简化赋值
          const {
            worksType,
            worksUrl: file,
            worksSize: size,
            status,
            isRegistered,
            registrationCode: registrationNumber,
            certificateUrl: certificateFile,
            title,
            keywords,
            category,
            finishTime: creationDate,
            finishAddress: creationPlace,
            portraitRight,
            opinion,
            duration,
            fileName,
          } = data;

          // 上传表单数据
          this.uploadForm = {
            ...this.uploadForm,
            type: String(worksType),
            file,
            size,
            duration,
            fileName,
            simCetiUrl: data.simCetiUrl,
            simCetiUrlName: data.simCetiUrlName,
            simImage: data.simImage,
            simResource: data.simResource,
          };

          // 审核表单数据
          this.reviewForm = {
            ...this.reviewForm,
            isRegistered: String(isRegistered),
            registrationNumber,
            certificateFile,
            title,
            keywords,
            category,
            creationDate,
            creationPlace,
            portraitRight: String(portraitRight),
            opinion,
            status,
          };
        }
      });
    },
    rejectReview() {
      // 审核拒绝逻辑，可发送请求到后端
      // this.dialogVisible = true;
      if (!this.reviewForm.opinion) {
        return this.$message.error("请输入审核意见");
      }
      console.log("审核拒绝");
      this.approve(3, this.reviewForm.opinion);
    },
    approveReview() {
      // 审核通过逻辑，可发送请求到后端
      this.approve(5, this.reviewForm.opinion);
      console.log("审核通过");
    },
    confirmRefuse(formRef) {
      this.$refs[formRef].validate((valid) => {
        if (valid) {
          this.dialogVisible = false;
          // 发送拒绝请求到后端
          console.log("拒绝原因:", this.dialogForm.reason);
          this.approve(3, this.dialogForm.reason);
        }
      });
    },
    goback() {
      this.$router.push({ path: "/listWorks" }); // 替换为实际的路由路径
    },
    getCategorizeFn() {
      this.$ajax.get(getCategorize, {}).then((res) => {
        if (res.data.code == 200) {
          this.categorizeList = res.data.data;
        }
      });
    },
    getPictureFn() {
      this.$ajax.get(getPicture, { type: this.uploadForm.type }).then((res) => {
        if (res.data.code == 200) {
          this.recommendedKeywords = res.data.data.map((item) => item.name);
        }
      });
    },
    getStatusCode(status) {
      const map = {
        5: "销售中",
        4: "待发布",
        1: "审核中",
        3: "未通过",
      };
      return map[status] || "";
    },
    approve(status, reason) {
      this.$ajax
        .post(updateStatus, {
          id: this.currentId,
          status: status,
          opinion: reason,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("操作成功");
            this.$router.push({ path: "/listWorks" }); // 替换为实际的路由路径
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.work-review-container {
  display: flex;
  background-color: #ffffff;
}

.left-section {
  width: 50%;
  padding: 20px;
}

.right-section {
  width: 50%;
  padding: 20px;
}

.image-container {
  display: flex;
  flex-wrap: wrap;
}

.image-item {
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
  width: 28%;
  margin-right: 2%;

  /deep/ .images {
    width: 100%;
    border-radius: 14px;

    .el-image__inner {
      width: 100%;
      height: 300px;
      object-fit: cover;
    }
  }
}
.similar-resource-box {
  display: flex;
}
.similar-item {
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
  width: 28%;
  margin-right: 2%;
  /deep/ .images {
    width: 100%;
    border-radius: 14px;

    .el-image__inner {
      width: 100%;
      height: 300px;
      object-fit: cover;
    }
  }
}
.watermark {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 5px;
}

.similar-resource {
  margin-top: 20px;
}

.similar-info {
  margin-left: 10px;
}

.keyword-tips {
  font-size: 12px;
  color: #999;
}

.recommended-keywords {
  margin-top: 5px;
  font-size: 12px;
  color: #999;

  span {
    background-color: #002b9c;
    color: #ffffff;
    text-align: center;
    padding: 4px 8px;
    border-radius: 6px;
    display: inline-block;
    line-height: 20px;
    margin-right: 10px;
  }
}
.audit {
  font-weight: 400;
  font-size: 14px;
  color: #ff0000;
  margin-top: 20px;
}
.title-status {
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}

.el-button--primary {
  color: #fff;
  background-color: #002b9c;
  border-color: #002b9c;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #002b9c;
  background: #002b9c;
}

/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #002b9c;
}

.automatic {
  background: #f6f9ff;
  border-radius: 0px 0px 0px 0px;
  padding: 10px;
  margin-bottom: 30px;

  .automatic-tit {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #444444;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .automatic-count {
    margin-top: 10px;
    display: flex;

    div {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #444444;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-right: 30px;
    }
  }
}
.title-tip {
  margin-bottom: 16px;
}
</style>
